<header class="flex header">
  <h2>{{ 'Lots_Modal_Add_Lots' | translateWF: 'Add Lots' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content modal-content">
  <p-toast></p-toast>

  @if (isConsignment) {
    <div class="form-box mb-4">
      <label for="">{{ 'Shipment_Delivery_Note' | translateWF: 'Delivery Note' }}</label>
      <p-select appendTo="body" [formControl]="selectedDeliveryNote" [options]="deliveryNoteOptions" optionLabel="number" optionValue="id" class="w-full required" />
    </div>

    @if (selectedDeliveryNote.value) {
      <div class="form-box mb-4">
        <label for="">{{ 'Work_Order' | translateWF: 'Work Order' }}</label>
        <p-select appendTo="body" [formControl]="selectedWorkOrder" [options]="workOrderOptions" optionLabel="label" optionValue="value" class="w-full required" />
      </div>
    }
  } @else {
    <div class="form-box mb-4">
      <label for="">{{ 'Lots_Modal_Invoice' | translateWF: 'Invoice' }}</label>
      <p-autocomplete
        appendTo="body"
        [suggestions]="invoiceOptions"
        [field]="'invoiceNumber'"
        [formControl]="selectedInvoice"
        (completeMethod)="invoiceTypeAhead($event)"
        [dropdown]="true"
        [forceSelection]="true"
        (onSelect)="selectInvoice(undefined, $event.value.id); itemCode.reset('')"
      />
    </div>

    @if (selectedInvoice.value && purchaseOrderOptions.length > 0) {
      <div class="form-box mb-4">
        <label for="">{{ 'Lots_Modal_Purchase_Order' | translateWF: 'Purchase Order' }}</label>
        <p-select appendTo="body" [formControl]="selectedPurchaseOrder" [options]="purchaseOrderOptions" optionLabel="label" optionValue="value" class="w-full required" />
      </div>
    }
  }

  @if (batchImport.value && !isConsignment && selectedPurchaseOrder.value) {
    <div class="form-box mb-4">
      @if (canSelectItem) {
        <label for="">{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</label>
        <p-select
          appendTo="body"
          [formControl]="itemCode"
          [options]="getItemOptions(selectedInvoice.value!.id!, getPurchaseOrderById(selectedPurchaseOrder.value!)?.id!)"
          optionLabel="label"
          optionValue="value"
          class="w-full required"
        />
      }
    </div>
  }

  @if (batchImport.value && isConsignment && selectedDeliveryNote.value && selectedWorkOrder.value) {
    <div class="form-box mb-4">
      <label for="">{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</label>
      <p-select appendTo="body" [formControl]="itemCode" [options]="getItemOptionsForDeliveryNote()" optionLabel="label" optionValue="value" class="w-full required" />
    </div>
  }

  @if (itemCode.value) {
    <div class="form-box mb-4" *ngIf="itemCode.value && invoiceOptions.length > 0">
      <label for="">{{ 'Lots_Modal_Unit_Of_Measure' | translateWF: 'Unit Of Measure' }}</label>
      <input type="text" [value]="isConsignment ? getUomForSelectedItem() : getUomForItemCode(itemCode.value!)" pInputText [disabled]="true" />
    </div>

    <div class="drop__wrapper mb-[1rem]" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <p>{{ 'Lots_Modal_Drag_Drop' | translateWF: 'Drag & Drop your file here or' }}</p>
      <input type="file" id="fileInput" (change)="onFileChange($event)" accept=".xlsx" hidden />
      <label for="fileInput" class="btn">{{ 'Lots_Modal_Select_File' | translateWF: 'Select File' }}</label>
    </div>
    <section>
      @if (isConsignment) {
        <h3>{{ 'Lots_Modal_Client' | translateWF: 'Client' }}</h3>
        <p *ngIf="deliveryNoteClient?.name">{{ deliveryNoteClient?.name }}</p>
        <p *ngIf="!deliveryNoteClient" class="text-gray-500">{{ 'No_Client_Data' | translateWF: 'No client data available' }}</p>
        <div *ngIf="deliveryNoteClient && deliveryNoteClient.lotNumbers && deliveryNoteClient.lotNumbers.length > 0">
          <label for="">{{ 'Lots_Modal_Items' | translateWF: 'Lot Numbers' }}</label
          ><br />
          <p-tag *ngFor="let items of deliveryNoteClient.lotNumbers" class="mr-2">{{ items }}</p-tag>
        </div>
      } @else {
        <h3>{{ 'Lots_Modal_Manufacturer' | translateWF: 'Manufacturer' }}</h3>
        <p *ngIf="manufacturer?.name">{{ manufacturer?.name }}</p>
        <p *ngIf="!manufacturer" class="text-gray-500">
          {{
            'No_Manufacturer_Data'
              | translateWF
                : 'No manufacturer data
      available'
          }}
        </p>
        <div *ngIf="manufacturer">
          <label for="">{{ 'Lots_Modal_Items' | translateWF: 'Lot Numbers' }}</label
          ><br />
          <p-tag *ngFor="let items of manufacturer.lotNumbers" class="mr-2">{{ items }}</p-tag>
        </div>
      }
    </section>

    <section class="instructions-box">
      <h3>{{ 'Lots_Modal_Instructions' | translateWF: 'Instructions' }}</h3>
      <p>
        {{
          'Lots_Modal_Instructions_Text'
            | translateWF
              : 'Please make sure your file follows the correct structure before uploading. You can download a
      template to help you format your data properly.'
        }}
      </p>
      <a href="assets/Sample-Template.xlsx" download class="btn btn-download">
        <span class="material-icons">file_download</span>
        {{ 'Lots_Modal_Download_Template' | translateWF: 'Download Template' }}
      </a>
    </section>
  }

  <loading-overlay [isLoading]="isImporting"></loading-overlay>

  @if (errors.length > 0) {
    <div class="errors">
      <h3>{{ 'Lots_Modal_Errors' | translateWF: 'Errors:' }}</h3>
      <ul>
        @for (error of errors; track $index) {
          <li>
            @if (error.rowNumber) {
              {{ 'Lots_Modal_Row' | translateWF: 'Row' }} {{ error.rowNumber }}:
            }
            {{ error.message }}
          </li>
        }
      </ul>
    </div>
  }

  @if (importedData.length > 0) {
    <div>
      <h4>{{ 'Lots_Modal_Valid_Data' | translateWF: 'Valid Data:' }}</h4>
      <p-table [value]="importedData" styleClass="cs-datatable-max-h-modal">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Lots_Modal_Provider_Lot' | translateWF: 'Provider Lot' }}</th>
            <th>{{ 'Lots_Modal_Label_Number' | translateWF: 'Label Number' }}</th>
            <th>{{ 'Shipment_Details_Packaging_Type' | translateWF: 'Packaging Type' }}</th>
            <th>{{ 'Lots_Modal_Gross_Quantity' | translateWF: 'Gross Quantity' }}</th>
            <th>{{ 'Lots_Modal_Net_Quantity' | translateWF: 'Net Quantity' }}</th>
            <th>{{ 'Lots_Modal_Manufactured_Week_Year' | translateWF: 'Manufactured Week/Year' }}</th>
            <th>{{ 'Lots_Modal_Expiry_Date' | translateWF: 'Expiry Date' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr class="cursor-pointer">
            <td>{{ item.providerLot }}</td>
            <td>{{ item.labelNumber }}</td>
            <td>{{ packagingType[item.packagingType] }}</td>
            <td>{{ item.grossQuantity }}</td>
            <td>{{ item.netQuantity }}</td>
            <td>{{ item.manufacturedWeekAndYear || 'N/A' }}</td>
            <td>{{ item.expiryDate ? (item.expiryDate | date: 'yyyy-MM-dd') : 'N/A' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</section>

<footer>
  <p-button class="w-full" [label]="'Add' | translateWF: 'Add'" [disabled]="isFormInvalid" (click)="save()" />
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
